import { Globe } from "lucide-react";

export function LeadsEmptyState() {
  return (
    <div className="relative flex flex-1 flex-col items-center justify-center overflow-hidden px-6 py-12 text-center">
      <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl border border-border bg-muted text-muted-foreground">
        <Globe className="h-5 w-5" aria-hidden />
      </div>
      <h3 className="text-base font-medium text-foreground">No leads yet</h3>
      <p className="mt-2 max-w-xs text-sm leading-relaxed text-muted-foreground">
        Form submissions from your published site appear here once visitors submit a contact or
        intake form.
      </p>
    </div>
  );
}
